module.exports = __webpack_public_path__ + "img/1-4.90edc31b.svg";